const ErrorActionTypes = {
    ERROR: "mostrar/erro",
}

export default ErrorActionTypes;